import { Link } from 'react-router-dom';
import { Brain } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neureka-purple-dark border-t border-white/10 mt-auto">
      <div className="container mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-2 text-sm text-white/50">
        {/* Logo + Copyright */}
        <div className="flex items-center gap-2">
          <Brain className="w-4 h-4 text-neureka-yellow" />
          <span>© {currentYear} Neureka</span>
        </div>

        {/* Enlaces */}
        <nav className="flex items-center gap-4">
          <Link to="/juegos" className="hover:text-white transition-colors">Juegos</Link>
          <Link to="/about" className="hover:text-white transition-colors">Sobre Neureka</Link>
          <Link to="/privacy" className="hover:text-white transition-colors">Privacidad</Link>
          <a href="mailto:info@neureka.es" className="text-neureka-yellow hover:underline">info@neureka.es</a>
        </nav>
      </div>
    </footer>
  );
}
